cb.define(['common/common_VM.Extend.js'], function(common) {
  //var _util = require('../../../helpers/util');

  var ST_st_storecheckprepare_VM_Extend = {
    doAction: function(name, viewmodel) {
     if(this[name])
      this[name](viewmodel);
    },
    init: function(viewmodel) {

      //编辑态不允许修改仓库
      var mode = viewmodel.getParams().mode;
      if(mode == 'edit') {
        viewmodel.get("warehouse_name").setReadOnly(true);
      }
      viewmodel.on("afterEdit", function(data) {
        // if(data == 'edit') {
          viewmodel.get("warehouse_name").setReadOnly(true);
        // }
      });  
      //参照弹出之前如果仓库为空，提示先设置仓库
      viewmodel.getGridModel().on('beforeBrowse', function(data) {
        var warehouseId = viewmodel.get("warehouse").getValue();
        if(warehouseId == undefined || warehouseId == null || warehouseId == ''){
          cb.utils.alert("请先设置仓库！");
          return false;
        }
      });
      //向后台传递行号
      viewmodel.getGridModel().setState('orderField', 'rowno');
      //选择完商品之后，商品落到表体行之前，请求后台，处理数据
      viewmodel.getGridModel().on("beforeInsertRowsFromRefer", function(args) {
        debugger
        var promise = new cb.promise();
        var storeId = viewmodel.get("store").getValue();
        var warehouseId = viewmodel.get("warehouse").getValue();
        if(warehouseId == undefined || warehouseId == null || warehouseId == ''){
          cb.utils.alert("请先设置仓库！");
          return false;
        }
        var params = {
          store: storeId,
          warehouse: warehouseId,
          productinfos: args.rows
        };

        var queryStockBatchnoAndRemoveExistsProxy = cb.rest.DynamicProxy.create({
          settle: {
            url: '/billingretail/getStockBatchnoExpiryDateAndRemoveExists',
            method: 'POST'
          }
        });

        queryStockBatchnoAndRemoveExistsProxy.settle(params, (err, result) => {
          // getGridModel.insertRows(0,[{b:'',a:'',c:''}]);
          if (err) {
            cb.utils.alert(err.message, 'error');
            return;
          }

          if(result === undefined) {
            cb.utils.alert("查询商品库存、批次、效期异常！", 'error');
            return;
          }

          // 根据result重置args.rows
          args.rows.splice(0, args.rows.length);
          for(var i = 0; i < result.length; i++){
            args.rows.splice(-1, 0, result[i]);
          }
          promise.resolve();
        });

        return promise;
      });
    }
  };

  try {
    module.exports = ST_st_storecheckprepare_VM_Extend;
  } catch(error) {

  }
  return ST_st_storecheckprepare_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckprepare_VM.Extend.js